import type { ProgramProgressCell } from '../types/domain';
import {
  mapProgressLikeToDisplayFields,
  programProgressCellToProgressLike,
} from './annualProgressFieldDisplay';
import type { AnnualCrossTopicDetailRow } from './annualProgressCrossTopicExtract';
import { resolveProgramExportTemplateLabelParts } from './programExportDocumentTitle';
import type { ProgramProgressRow } from './programProgressRows';

function resolveProgramExportRowTemplateParts(
  row: ProgramProgressRow,
  cell: ProgramProgressCell | undefined
) {
  const track = (row.templateLabel ?? '').trim();
  const timetable = String(cell?.timetable_text ?? row.timetableText ?? '').trim();
  return resolveProgramExportTemplateLabelParts(track, timetable);
}

export function buildProgramLearningContentDetailRows(
  tableRows: ProgramProgressRow[],
  programCellsByAnnualKey: Record<string, ProgramProgressCell>
): AnnualCrossTopicDetailRow[] {
  const out: AnnualCrossTopicDetailRow[] = [];
  let seq = 0;
  for (const row of tableRows) {
    const cell = programCellsByAnnualKey[row.annualCellKey];
    const d = mapProgressLikeToDisplayFields(cell ? programProgressCellToProgressLike(cell) : null);
    const templateParts = resolveProgramExportRowTemplateParts(row, cell);
    seq += 1;
    out.push({
      dateLabel: row.isScheduleAvailable === false ? '' : row.dateLabel,
      weekdayLabel: row.isScheduleAvailable === false ? '' : row.weekdayLabel,
      periodLabel: row.isScheduleAvailable === false ? '' : row.periodLabel,
      templateLabel: templateParts.flatLabel,
      templateTrackLabel: templateParts.trackLabel,
      templateTimetableLabel: templateParts.timetableLabel,
      unit: d.progressUnit,
      learning: d.progressLearning,
      page: d.progressPage,
      assistantPage: d.progressAssistantPage,
      currentPeriod: d.progressCurrentPeriod,
      totalPeriod: d.progressTotalPeriod,
      material: d.progressMaterial,
      crossTopic: d.progressCross,
      crossNote: d.progressCrossNote,
      mondayIso: row.mondayIso,
      weekdayKey: row.weekdayKey,
      slotIndex: row.slotIndex,
      seq,
    });
  }
  return out;
}

export function programLearningContentDetailRowsHaveData(rows: AnnualCrossTopicDetailRow[]): boolean {
  return rows.some(
    (row) =>
      row.dateLabel ||
      row.unit ||
      row.learning ||
      row.page ||
      row.assistantPage ||
      row.currentPeriod ||
      row.totalPeriod ||
      row.material ||
      row.crossTopic
  );
}
